import { useState, useEffect } from "react";
import { signInWithPopup, signInWithRedirect, getRedirectResult, signOut } from "firebase/auth";
import { auth, googleProvider } from "../../firebase";
import { useAuth } from "../../AuthContext";
import './Login.sass';

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

function GoogleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
            <path d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 6.293C4.672 4.166 6.656 3.58 9 3.58z" fill="#EA4335"/>
        </svg>
    );
}


export default function Login() {
    const { user } = useAuth();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isIOS) return;
        setLoading(true);
        getRedirectResult(auth)
            .catch(err => {
                if (err.code !== 'auth/cancelled-popup-request') {
                    setError("Inloggning misslyckades. Försök igen.");
                    console.error("Redirect result failed:", err);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    async function handleLogin(provider) {
        setError(null);
        setLoading(true);
        try {
            if (isIOS) {
                await signInWithRedirect(auth, provider);
            } else {
                await signInWithPopup(auth, provider);
            }
        } catch (err) {
            if (err.code !== 'auth/popup-closed-by-user' && err.code !== 'auth/cancelled-popup-request') {
                setError("Inloggning misslyckades. Försök igen.");
                console.error("Login failed:", err);
            }
            setLoading(false);
        }
    }

    async function handleSignOut() {
        try {
            await signOut(auth);
        } catch (err) {
            console.error("Sign out failed:", err);
        }
    }

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <h1>Svärmorsdrömmar</h1>
                    <span>Snacka med Ledel för inlogg </span>
                </div>

                <hr className="login-divider" />

                {user ? (
                    <div className="login-signed-in">
                        <p className="login-signed-in-text">Inloggad som {user.displayName || user.email}</p>
                        <button className="login-signout-btn" onClick={handleSignOut}>
                            Logga ut
                        </button>
                    </div>
                ) : (
                    <div className="login-buttons">
                        <button className="login-google-btn" onClick={() => handleLogin(googleProvider)} disabled={loading}>
                            <GoogleIcon />
                            {loading ? "Loggar in..." : "Fortsätt med Google"}
                        </button>
                    </div>
                )}

                {error && <p className="login-error">{error}</p>}
            </div>
        </div>
    );
}
